module.exports = __webpack_public_path__ + "media/enemy-hurt.f0b5f998.mp3";